export default function dollarAmount(amount, withDecimal = true) {
  if (amount == null || amount === "") return "";

  const isNegative = parseFloat(amount) < 0;
  const cleaned = String(amount).replace(/[^0-9.]/g, "");
  const parsed = parseFloat(cleaned);

  if (isNaN(parsed) || !isFinite(parsed)) return "";

  const formatted = (
    withDecimal ? parsed.toFixed(2) : parsed.toFixed(0)
  ).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${isNegative ? "-" : ""}$${formatted}`;
}
